import { HStack, Text } from '@direct-frontend/components';
import { type ImageInfo } from '@/shared/api/image';
import { ResponsiveImage } from '@/shared/components/ResponsiveImage';
import styles from './OutdatedStockItem.module.css';

export interface OutdatedStockItemProps {
    name: string;
    caption?: string;
    image: ImageInfo;
    quantity: number;
    quantityOld: number;
    size?: string;
}

export const OutdatedStockItem = (props: OutdatedStockItemProps) => {
    const { name, caption, image, quantity, quantityOld, size } = props;

    return (
        <HStack gap="20" alignItems="stretch" className={styles.root}>
            <div className={styles.imageContainer}>
                <ResponsiveImage width="100%" height="100%" src={image} borderRadius="8" alt={name} />
            </div>
            <div className={styles.content}>
                <div className={styles.title}>
                    <Text size="s">{name}</Text>
                    <Text size="s" role="supplementary">
                        {caption}
                    </Text>
                    <Text size="s">{size}</Text>
                </div>
                {quantity > 0 ? (
                    <div className={styles.quantityContainer}>
                        <Text size="s" className={styles.quantity}>
                            {quantity} шт.
                        </Text>
                        {quantity && quantity !== quantityOld && (
                            <Text size="xs" role="supplementary" className={styles.quantityOld}>
                                {quantityOld} шт.
                            </Text>
                        )}
                    </div>
                ) : (
                    <Text size="s" className={styles.quantity}>
                        Распродано
                    </Text>
                )}
            </div>
        </HStack>
    );
};
